export default __webpack_public_path__ + "maps-overview-symbol-layer-1200-7e343268bbd7b6ef3570b34cdd6e86ec.png";